import { render, staticRenderFns } from "./AnnounceShipmentModal.vue?vue&type=template&id=27579320&scoped=true&"
import script from "./AnnounceShipmentModal.vue?vue&type=script&lang=js&"
export * from "./AnnounceShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceShipmentModal.vue?vue&type=style&index=0&id=27579320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27579320",
  null
  
)

export default component.exports